export default __webpack_public_path__ + "static/media/KZ.T.04.2346.7f4d977c.svg";